"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleStyled = void 0;
const constants_1 = require("../../theme/constants");
exports.TitleStyled = styled.h1 `
&.octo {
  font-weight: 600;
  text-transform: capitalize;

  > span {
    @media (min-width: ${constants_1.sizes.tablet}) {
      font-size: 2.5em;
    }

    @media (max-width: ${constants_1.sizes.tablet}) {
      font-size: 2em;
    }
  }
}
`;
//# sourceMappingURL=Title.styled.js.map